import React from 'react';
import { Alert } from 'reactstrap';

const Error = (props: { [label: string]: any, content: any }) => {
    return (
        <div>
            <Alert style={{ borderRadius: '15px', border: 'none', background: 'none' }}>
                <p style={{ margin: 0, textAlign: "center", color: '#1931b9' }}>
                    {props.content}
                </p>
            </Alert>
        </div>
    );
};

export default Error;


// WEBPACK FOOTER //
// ./src/components/alerts/Error.tsx